import { DISCLAIMER } from '../config/constants'

function ShieldCheck() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l7 3v5c0 4.5-3 8.3-7 9.5-4-1.2-7-5-7-9.5V6l7-3z" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.5 12l1.8 1.8 3.2-3.6" />
    </svg>
  )
}

export default function Disclaimer({ text = DISCLAIMER }) {
  return (
    <div className="mt-4 flex gap-2.5 rounded-2xl border border-hairline bg-white/50 p-3.5 backdrop-blur">
      <ShieldCheck />
      <p className="text-[12px] leading-relaxed text-muted">{text}</p>
    </div>
  )
}
